// Base html font size
export const htmlFontSize = 16
